import { ResourceType, SearchPage } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

export interface ListingFilters {
  searchTerm?: string;
  keyStages?: string[];
  traits?: string[];
  contentTypes?: string[];
}

interface SearchingState {
  filters: ListingFilters;
  searchPage: { searchPage: SearchPage | null; resourceTypes: ResourceType[] };
  fixedTypes: string[];
  updateFilters: (filters: ListingFilters) => void;
  setSearchPage: (searchPage: SearchPage, resourceTypes: ResourceType[]) => void;
  handleToggleFilter: (field: keyof ListingFilters, value: string) => void;
  clearFilters: () => void;
}

export const useSearchingStore = create<SearchingState>((set, get) => ({
  filters: {
    searchTerm: '',
    keyStages: [],
    traits: [],
    contentTypes: [],
  },
  fixedTypes: ['Programmes', 'Missions', 'Courses'],
  searchPage: { searchPage: null, resourceTypes: [] },
  setSearchPage: (searchPage, resourceTypes) => {
    set({ searchPage: { searchPage, resourceTypes } });
  },
  updateFilters: (filters: ListingFilters) => {
    set({ filters });
  },
  handleToggleFilter: (field: keyof ListingFilters, value: string) => {
    const filters = get().filters;
    const currentArray = (filters[field] as string[]) || [];
    const isSelected = currentArray.includes(value);
    const newArray = isSelected ? currentArray.filter((item) => item !== value) : [...currentArray, value];
    const newFilters = { ...filters, [field]: newArray };
    set({ filters: newFilters });
  },
  clearFilters: () => {
    set({
      filters: {
        searchTerm: '',
        keyStages: [],
        traits: [],
        contentTypes: [],
      },
    });
  },
}));
